import { useMemo } from 'react'
import { getServiceLocationTitle } from '@sales-center/common'
import { LocationDTO } from '@sales-center/common'

export function useGetServiceLocationListPropAddressBlock(params: LocationDTO) {
  const title = useMemo(() => getServiceLocationTitle(params), [params])
  const serviceLocationRowFormatted = `Service Location: ${title}`

  return {
    serviceLocationRowFormatted,
  }
}
